import { RootState } from "../store/store";
import { ItemCreateRequest } from "../types/index";

type LocationState = RootState["location"]["location"];

export const buildItemFormData = (
  itemData: ItemCreateRequest,
  options?: {
    images?: File[];
    includeUserId?: boolean;
    includeImageIds?: boolean;
  }
): FormData => {
  const formData = new FormData();

  // Append image files if provided
  if (options?.images && options.images.length > 0) {
    options.images.forEach((image) => {
      if (image instanceof File) {
        formData.append("images", image);
      }
    });
  }

  const itemRequest: Record<string, any> = {
    name: itemData.name,
    description: itemData.description,
    condition: itemData.condition,
    category: itemData.category,
    lat: itemData.lat,
    lon: itemData.lon,
    address: itemData.address,
  };

  if (options?.includeUserId && itemData.userId) {
    itemRequest.userId = itemData.userId;
  }

  if (options?.includeImageIds) {
    itemRequest.imageIds = (itemData.imageURL || [])
      .map((img) => {
        const uploadLikeImage = img as any;
        if (typeof uploadLikeImage?.id === "string" && uploadLikeImage.id.trim()) {
          return uploadLikeImage.id;
        }
        if (
          typeof uploadLikeImage?.uid === "string" &&
          !uploadLikeImage.originFileObj &&
          uploadLikeImage.uid.trim()
        ) {
          return uploadLikeImage.uid;
        }
        return null;
      })
      .filter((id): id is string => Boolean(id));
  }

  const itemRequestBlob = new Blob([JSON.stringify(itemRequest)], {
    type: "application/json",
  });
  formData.append("itemRequest", itemRequestBlob);

  return formData;
};

export const getUserIdFromContext = (state: RootState): string | null => {
  const userId = state.auth.userId;
  if (!userId) {
    return null;
  }
  return userId;
};

export const getLocationFromContext = (state: RootState): LocationState | null => {
  const locationState = state.location.location;
  if (!locationState) {
    return null;
  }
  return locationState;
};

export function getSsoApiBaseUrl(): string {
  const raw = (process.env.REACT_APP_SSO_API_URL || "").trim().replace(/\/$/, "");
  if (!raw) {
    return raw;
  }
  if (
    typeof window !== "undefined" &&
    window.location.protocol === "https:" &&
    raw.startsWith("http://")
  ) {
    try {
      const { hostname } = new URL(raw);
      if (hostname === "localhost" || hostname === "127.0.0.1") {
        return raw;
      }
    } catch {
      return raw;
    }
    return `https://${raw.slice("http://".length)}`;
  }
  return raw;
}
